module.exports = __webpack_public_path__ + "img/reservation-success.a6474e0d.png";